<div class="breadcrubms">
  {#if breadcrumbs.length}
    <ul class="breadcrumbs-list list-unstyled d-flex justify-content-center">
      {#each breadcrumbs as { title, url }, index}
      <li
        class="breadcrumbs-list__item"
        class:active={!url}
      >
        {#if url}
          <a href={url}>{title}</a>
        {:else}
          <span>{title}</span>
        {/if}
      </li>
        {#if breadcrumbs[index + 1]}
          <li class="dicimer mr-2 ml-2 d-none d-sm-block">-</li>
        {/if}
      {/each}
    </ul>
  {/if}
</div>

<style>
  .breadcrubms {
    margin: auto;
    .breadcrumbs-list {
      @media (max-width: 767px) {
        flex-direction: column;
      }
    }
    .breadcrumbs-list__item {
      font-size: 1rem;
      @media (max-width: 767px) {
        text-align: center;
        &:not(:last-child) {
          margin-bottom: 20px;
        }
      }
      a {
        font-family: "Myriad Pro Light";
        line-height: 1.375rem;
        font-size: 0.875rem;
        letter-spacing: 0.09em;
        color: #000000;
      }
    }
    .breadcrumbs-list__item.active {
      a {
        font-family: "Myriad Pro SemiBold";
      }
    }
  }
</style>
